import React from "react"
import { CloseIcon } from "../../Icons"
import "./TagsField.css"

class TagsField extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      items: this.props.items || [],
      focused: false,
      input: ""
    }
  }

  handleInputChange = e => {
    this.setState({ input: e.target.value })
  }

  handleInputKeyDown = e => {
    if (e.keyCode === 13 && e.target.value === "") {
      e.preventDefault()
      return false
    }
    if (e.keyCode === 13 && e.target.value !== "") {
      const { value } = e.target

      this.setState(
        state => ({
          items: [...state.items, value],
          input: ""
        }),
        () => {
          const { name } = this.props.field
          const { setFieldValue } = this.props.form
          setFieldValue(name, this.state.items)
        }
      )
      e.preventDefault()
      return false
    }

    if (
      this.state.items.length &&
      e.keyCode === 8 &&
      !this.state.input.length
    ) {
      this.setState(state => ({
        items: state.items.slice(0, state.items.length - 1)
      }))
    }
  }

  handleRemoveItem = index => {
    this.setState(
      state => ({
        items: state.items.filter((item, i) => i !== index)
      }),
      () => {
        const { name } = this.props.field
        const { setFieldValue } = this.props.form
        setFieldValue(name, this.state.items)
      }
    )
  }

  handleBlur = () => {
    const { value } = this.state.input
    console.log(value)
    this.setState(
      state => ({
        items: [...state.items, value],
        input: ""
      }),
      () => {
        const { name } = this.props.field
        const { setFieldValue } = this.props.form
        setFieldValue(name, this.state.items)
      }
    )
  }

  componentDidUpdate(prevProps) {
    if (this.props.items !== prevProps.items) {
      this.setState(state => ({
        ...state,
        items: this.props.items
      }))
    }
  }

  render() {
    return (
      <div className="TagsField">
        <input
          value={this.state.input}
          onChange={this.handleInputChange}
          onKeyDown={this.handleInputKeyDown}
          onBlur={this.handleBlur}
          type="text"
        />
        <label>
          <ul>
            {this.state.items.map((item, i) => (
              <li key={i}>
                {item}
                <span onClick={this.handleRemoveItem.bind(this, i)}>
                  <CloseIcon />
                </span>
              </li>
            ))}
          </ul>
        </label>
      </div>
    )
  }
}

export default TagsField
